
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/produtos/mais-hair",
      function () {
        return require("private-next-pages/produtos/mais-hair.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/produtos/mais-hair"])
      });
    }
  